import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.flags";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SET_FLAG = 'classpass/page/SET_FLAG';
var TOGGLE_FLAG = 'classpass/page/TOGGLE_FLAG';
var USE_DARK_SELL_HEADER = 'classpass/page/USE_DARK_SELL_HEADER';
var USE_REDUCED_NAV = 'classpass/page/USE_REDUCED_NAV';
var USE_REDUCED_FOOTER = 'classpass/page/USE_REDUCED_FOOTER';
var USE_SELL_HEADER = 'classpass/page/USE_SELL_HEADER';
var SET_LOGO_LINK = 'classpass/page/SET_LOGO_LINK';
var SET_PAGE_PROMOTION = 'classpass/page/SET_PAGE_PROMOTION';
export var setFlag = function setFlag(key, value) {
  return {
    type: SET_FLAG,
    data: {
      key: key,
      value: value
    }
  };
};
export var toggleFlag = function toggleFlag(key) {
  return {
    type: TOGGLE_FLAG,
    data: key
  };
};
export var setLogoLink = function setLogoLink(path) {
  return {
    type: SET_LOGO_LINK,
    data: path
  };
};
export var clearLogoLink = setLogoLink.bind(null, null);
export var useDarkSellHeader = function useDarkSellHeader() {
  var use = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return {
    type: USE_DARK_SELL_HEADER,
    data: use
  };
};
export var useReducedNavigation = function useReducedNavigation() {
  var use = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return {
    type: USE_REDUCED_NAV,
    data: use
  };
};
export var useReducedFooter = function useReducedFooter() {
  var use = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return {
    type: USE_REDUCED_FOOTER,
    data: use
  };
};
export var useSellHeader = function useSellHeader() {
  var use = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return {
    type: USE_SELL_HEADER,
    data: use
  };
};
export var setPagePromotion = function setPagePromotion(promotion) {
  return {
    type: SET_PAGE_PROMOTION,
    data: promotion
  };
};
export var selectPagePromotion = function selectPagePromotion(state) {
  return state.page.pagePromotion;
};
export var getInitialState = function getInitialState() {
  return {
    reducedNav: false,
    reducedFooter: false,
    sellHeader: false,
    flags: {
      showCookiePolicy: true
    },
    logoLink: null,
    pagePromotion: null
  };
};
export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_FLAG:
      return _objectSpread({}, state, {
        flags: _objectSpread({}, state.flags, _defineProperty({}, action.data.key, action.data.value))
      });

    case TOGGLE_FLAG:
      return _objectSpread({}, state, {
        flags: _objectSpread({}, state.flags, _defineProperty({}, action.data, !state.flags[action.data]))
      });

    case USE_DARK_SELL_HEADER:
      return _objectSpread({}, state, {
        sellHeader: action.data,
        darkNav: action.data
      });

    case USE_REDUCED_NAV:
      return _objectSpread({}, state, {
        reducedNav: action.data
      });

    case USE_REDUCED_FOOTER:
      return _objectSpread({}, state, {
        reducedFooter: action.data
      });

    case USE_SELL_HEADER:
      return _objectSpread({}, state, {
        sellHeader: action.data
      });

    case SET_LOGO_LINK:
      return _objectSpread({}, state, {
        logoLink: action.data
      });

    case SET_PAGE_PROMOTION:
      return _objectSpread({}, state, {
        pagePromotion: action.data
      });

    default:
      return state;
  }
}